import React, { FC, MouseEventHandler, useEffect, useState } from 'react'

import { useOutletContext } from 'react-router-dom'

import SearchResults from '@components/music/SearchResults'
import FilterRow from '@components/music/filter/FilterRow'
import useWindowSize from '@hooks/useWindowSize'
import { ViewType } from '@utils/global'
import { isMobileLayout } from '@utils/mobile'
import Storage from '@utils/storage'

const SearchPage: FC = () => {
  const { width } = useWindowSize()
  const [layoutType, setLayoutType] = useState(Storage.productsViewType)
  const { setSideFilterVisibility } =
    useOutletContext<{ setSideFilterVisibility: MouseEventHandler }>()

  const setViewType = (type: ViewType): void => {
    setLayoutType(type)
    Storage.productsViewType = type
  }

  useEffect(() => {
    if (width && layoutType !== ViewType.THUMBNAIL && isMobileLayout(width))
      setViewType(ViewType.THUMBNAIL)
  }, [width, layoutType])

  return (
    <div className="flex flex-col flex-1 h-full w-0" data-testid="music-search-page">
      <FilterRow
        setViewType={setViewType}
        viewType={layoutType}
        onClickFilter={setSideFilterVisibility}
      />
      <SearchResults layoutType={layoutType} />
    </div>
  )
}

export default SearchPage
